import { camelCase, isNumber, upperFirst } from 'lodash';
import type { Node } from 'ricos-schema';
import {
  PluginContainerData_Alignment as ALIGNMENT,
  PluginContainerData_Width_Type as SIZE,
} from 'ricos-schema';
import styles from 'wix-rich-content-common/dist/statics/styles/general.rtlignore.scss';

export const alignmentClassName = (node: Node) => {
  const { alignment, width } = node.imageData?.containerData || {};
  if (!alignment) {
    return '';
  }
  let align = alignment;
  if (width?.size === SIZE.ORIGINAL && alignment !== ALIGNMENT.CENTER) {
    const { width } = node.imageData?.image || {};
    if (isNumber(width) && width > 350) {
      align = ALIGNMENT.CENTER;
    }
  }
  return styles[`align${upperFirst(align.toLowerCase())}`];
};

export const sizeClassName = (node: Node, isMobile: boolean) => {
  const { width } = node.imageData?.containerData || {};
  if (!width?.size || (isMobile && width?.size === SIZE.ORIGINAL)) {
    return '';
  }
  return width?.size === SIZE.FULL_WIDTH
    ? styles.sizeFullWidth
    : styles[`size${upperFirst(camelCase(width.size.toLowerCase()))}`];
};

export const textWrapClassName = (node: Node) => {
  const { textWrap } = node.imageData?.containerData || {};
  if (textWrap) {
    return '';
  }
  return styles.textWrapNowrap;
};
